import axios from 'axios';
import API_HOST from '../api';

const userApi = function() {
  const api = {};

  api.getClientDetails = function(clientId) {
    const url = `${API_HOST}/api/client/${clientId}`;
    return axios.get(url);
  };

  return api;
};

export default userApi();
